export const SET_COMPANY = 'SET_COMPANY';

export const setCompany = (company) => ({
    type: SET_COMPANY,
    payload: {
        company
    }
});

